import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    setOpenDropdown(null);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setOpenDropdown(null);
  };

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="logo" onClick={closeMobileMenu}>
          <img
            src="/images/logos/logo_final.png"
            alt="Clariti AI"
            className="logo-icon"
            loading="lazy"
          />
        </Link>

        <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <NavLink to="/" className="nav-link" onClick={closeMobileMenu}>
            Home
          </NavLink>
          
          <div className={`nav-dropdown ${openDropdown === 'products' ? 'is-open' : ''}`}>
            <div className="nav-dropdown-header nav-link" style={{ padding: 0, display: 'flex', alignItems: 'center', cursor: 'default' }}>
              <Link
                to="/products"
                onClick={(e) => {
                  if (mobileMenuOpen) {
                    e.preventDefault();
                    toggleDropdown('products');
                  } else {
                    closeMobileMenu();
                  }
                }}
                style={{ 
                  padding: '10px 4px 6px 20px', 
                  color: 'inherit', 
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  cursor: 'pointer'
                }}
              >
                Products
              </Link>
              <button
                className="nav-dropdown-btn"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown('products');
                }}
                aria-expanded={openDropdown === 'products'}
                style={{ 
                  padding: '10px 20px 6px 4px', 
                  background: 'none', 
                  border: 'none', 
                  color: 'inherit',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  fontFamily: 'inherit',
                  fontSize: 'inherit',
                  fontWeight: 'inherit',
                  width: 'auto'
                }}
                aria-label="Toggle Products menu"
              >
                <ChevronIcon />
              </button>
            </div>
            <div className="nav-dropdown-menu">
              <Link to="/products/mortgage" className="nav-dropdown-item" onClick={closeMobileMenu}>
                Mortgage Rate Optimisation
              </Link>
              <Link to="/products/savings" className="nav-dropdown-item" onClick={closeMobileMenu}>
                Savings Rate Optimisation
              </Link>
            </div>
          </div>

          <NavLink to="/about" className="nav-link" onClick={closeMobileMenu}>
            About
          </NavLink>

          <div className={`nav-dropdown ${openDropdown === 'resources' ? 'is-open' : ''}`}>
            <div className="nav-dropdown-header">
              <button 
                className="nav-link nav-dropdown-btn" 
                onClick={() => toggleDropdown('resources')}
                aria-expanded={openDropdown === 'resources'}
              >
                Resources
                <ChevronIcon />
              </button>
            </div>
            <div className="nav-dropdown-menu">
              <Link to="/insights" className="nav-dropdown-item" onClick={closeMobileMenu}>
                Insights
              </Link>
              <Link to="/webinars" className="nav-dropdown-item" onClick={closeMobileMenu}>
                Webinars
              </Link>
            </div>
          </div>

          <NavLink to="/careers" className="nav-link" onClick={closeMobileMenu}>
            Careers
          </NavLink>
          
          <div className="mobile-nav-buttons">
            <Link to="/contact" className="btn btn-primary" onClick={closeMobileMenu}>
              Book a Demo
            </Link>
          </div>
        </nav>

        <Link to="/contact" className="btn btn-primary header-cta">
          Book a Demo
        </Link>

        <button className="mobile-menu-btn" onClick={toggleMobileMenu} aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}

function ChevronIcon() {
  return (
    <svg className="chevron-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  );
}


export default Header;
